// Helper d'appel du relais /cdp du backoffice.
//
// Le relais /cdp applique desormais une garde de session (plan 092) : il peut
// repondre 401 (session absente ou expiree), 403 (acces refuse), ou 502/503
// (service indisponible). Chaque appelant doit donc tester res.ok et presenter
// une erreur lisible, au lieu de stocker un corps d'erreur comme une donnee
// valide (une reponse JSON d'erreur est un objet, donc « truthy » : `list || []`
// ne protege pas, et `.find` casse l'ecran).

const CDP_ERROR_MESSAGES = {
  401: 'Session expirée, veuillez vous reconnecter.',
  403: "Accès refusé : vous n'avez pas les droits nécessaires.",
  502: 'Service momentanément indisponible, veuillez réessayer plus tard.',
  503: 'Service momentanément indisponible, veuillez réessayer plus tard.',
  504: 'Service momentanément indisponible, veuillez réessayer plus tard.',
};

const buildCdpError = (status) => {
  const message =
    CDP_ERROR_MESSAGES[status] ||
    `Erreur ${status} lors de la communication avec le service.`;
  const error = new Error(message);
  error.status = status;
  return error;
};

// Appelle le relais /cdp et renvoie la reponse JSON. Leve une erreur portant le
// code HTTP (error.status) et un message par code quand la reponse n'est pas ok.
export const fetchCdpJson = async (url, options = {}) => {
  const res = await fetch(url, {
    credentials: 'same-origin',
    ...options,
  });
  if (!res.ok) {
    throw buildCdpError(res.status);
  }
  return res.json();
};

// Regle de retry pour react-query : ne relance jamais sur 401/403 (reessayer ne
// rendra pas la session valide), retente sinon jusqu'a deux fois.
export const cdpRetry = (failureCount, error) => {
  if (error && (error.status === 401 || error.status === 403)) {
    return false;
  }
  return failureCount < 2;
};
